const getMenu = (rootState) => rootState.ui.contextMenu.menu;

export default getMenu;
